export const arrangeColumns = (columns: [{ key: String; value: String }]) =>
  (columns || []).map((col, index) => ({
    key: col.key,
    value: col.value,
    index: col.key === 'symbol' || col.key === 'cik' ? 0 : index + 1,
    sort: true,
  }));
